<template>
  <div class="application">
    <div class="breadcrumb-content" v-if="$route.query.oid">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/orgin' }">{{oname}}</el-breadcrumb-item>
            <el-breadcrumb-item>应用管理</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="title-container">应用管理</div>
    <div class="application-container mg-top24">
      <div class="mg-bottom16">
        <el-button type="primary" size="small" @click="addApplication">创建应用</el-button>
      </div>
      <div class="table-container">
        <el-table :data="tableData" border v-loading="listLoading">
          <el-table-column prop="id" label="应用ID" min-width="90"></el-table-column>
          <el-table-column prop="app_name" label="应用名称" min-width="120"></el-table-column>
          <el-table-column prop="app_key" label="应用key" min-width="180"></el-table-column>
          <el-table-column prop="live_notify_url" label="直播回调地址" min-width="180"></el-table-column>
          <el-table-column prop="create_time" label="创建时间" min-width="160"></el-table-column>
          <el-table-column label="是否启用" min-width="90">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.is_enabled"
                @change="changeSwitch($event,scope.row)"
                active-color="#1678FF"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="250">
            <template slot-scope="scope">
              <el-button type="text" size="medium" @click="lookDetail(scope.row)">查看</el-button>
              <el-button type="text" size="medium" @click="applicationAuthorize(scope.row)">授权</el-button>
              <el-button type="text" size="medium" @click="resetSecret(scope.row)">重置SECRET</el-button>
              <el-button type="text" size="medium" @click="editApplication(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page-container text-align-right">
        <Pagination v-bind:child-msg="pageParams" @pageChange="pageChange"/>
      </div>
    </div>
    <div v-if="applicationDialog">
      <el-dialog :title="dialogTitle" :visible.sync="applicationDialog" width="580px" @close="closeHandle">
        <div class="applicationForm-content">
          <el-form :model="applicationForm" ref="applicationForm" :rules="rules" label-width="115px"
                   label-position="left">
            <el-form-item label="应用名称：" prop="app_name">
              <el-input v-model="applicationForm.app_name" placeholder="请输入应用名称"></el-input>
            </el-form-item>
            <el-form-item label="直播回调地址：">
              <el-input v-model="applicationForm.live_notify_url" placeholder="请输入直播回调地址"></el-input>
            </el-form-item>
            <el-form-item label="备注：">
              <el-input type="textarea" v-model="applicationForm.remark" placeholder="请输入备注" rows='5'></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="applicationDialog = false">取 消</el-button>
          <el-button type="primary" :loading="loading" size="small" @click="applicationHandle">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <div v-if="authorizeDialog">
      <el-dialog :title="dialogTitle" :visible.sync="authorizeDialog" width="545px">
        <div class="applicationForm-content">
          <el-form :model="authorizeForm">
            <el-form-item>
              <el-checkbox-group v-model="resourceIds">
                <el-checkbox border :label="item.id" v-for="(item,index) in resourceList" :key="index">{{item.name}}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="authorizeDialog = false">取 消</el-button>
          <el-button type="primary" :loading="authorizeLoading" size="small" @click="authorizeSave">保 存</el-button>
        </span>
      </el-dialog>
    </div>
    <div v-if="detailDialog">
      <el-dialog :title="dialogTitle" :visible.sync="detailDialog" width="545px">
        <el-form :model="detailForm" label-width="100px" label-position="left">
          <el-form-item label="APP ID：">
            <el-input v-model="detailForm.id" disabled></el-input>
          </el-form-item>
          <el-form-item label="APP KEY：">
            <el-input v-model="detailForm.app_key" disabled></el-input>
          </el-form-item>
          <el-form-item label="APP SECRET：">
            <el-input type="textarea" v-model="detailForm.app_secret" disabled></el-input>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import { detailOrgin } from '@/api/orgin/index'
  import { getuserInfo } from '@/utils/auth'
  import appApi from '@/api/system/application'
  import resourceApi from '@/api/system/resource'
  import Pagination from '@/components/Pagination'

  export default {
    name: 'application',
    data() {
      return {
        listLoading: false,
        queryParams: {
          page: 1,
          per_page: 10
        },
        pageParams: {
          currentPage: 1,
          pageSize: 10,
          total: 100
        },
        tableData: [],
        dialogTitle: '',
        applicationDialog: false,
        applicationId: '',
        applicationForm: {},
        authorizeDialog: false,
        authorizeForm: {
          resource: []
        },
        detailDialog: false,
        detailForm: {},
        resourceList: [],
        rules: {
          app_name: [
            { required: true, message: '应用名称不能为空', trigger: 'blur' }
          ]
        },
        loading: false,
        authorizeLoading: false,
        resourceIds: [],
        oname: ''
      }
    },
    created() {
      this.queryParams.create_by = this.$route.query.oid || JSON.parse(getuserInfo()).id
      this.getTableData()
      if (this.$route.query.oid) this.detailOrgin()
    },
    components: {
      Pagination
    },
    methods: {
      getTableData() {
        this.listLoading = true
        this.queryParams.page = this.pageParams.currentPage
        this.queryParams.per_page = this.pageParams.pageSize
        appApi.getList(this.queryParams).then(res => {
          if (res.code === 0) {
            this.tableData = res.data.list
            this.pageParams.total = res.data.total
          }
          this.listLoading = false
        }).catch((res) => {
          this.listLoading = false
        })
      },
      detailOrgin() {
        detailOrgin(this.queryParams.create_by).then(res => {
            if (res.code === 0) {
                this.oname = res.data.username
            }
        }).catch(res => {})
      },
      getResourceData() {
        let params = {
          page: 1,
          per_page: 999
        }
        resourceApi.getList(params).then(res => {
          if (res.code === 0) {
            this.resourceList = res.data.list
          }
        }).catch((err) => {
          console.log(err)
        })
      },
      addApplication() {
        this.applicationForm = {}
        this.dialogTitle = '创建应用'
        this.applicationDialog = true
      },
      editApplication(data) {
        this.applicationId = data.id
        console.log(data)
        this.applicationForm = data
        this.dialogTitle = '编辑应用'
        this.applicationDialog = true
      },
      applicationHandle() {
        this.$refs['applicationForm'].validate((valid) => {
          if (valid) {
            this.loading = true
            if (this.applicationId) {
              appApi.editApplication(this.applicationId, this.applicationForm).then(res => {
                if (res.code === 0) {
                  this.$message.success(res.msg)
                  this.applicationDialog = false
                  this.getTableData()
                }
                this.loading = false
              }).catch((err) => {
                this.loading = false
                console.log(err)
              })
            } else {
              appApi.addApplication(this.applicationForm).then(res => {
                if (res.code === 0) {
                  this.$message.success(res.msg)
                  this.applicationDialog = false
                  this.getTableData()
                }
                this.loading = false
              }).catch((err) => {
                this.loading = false
                console.log(err)
              })
            }
          }
        })
      },
      applicationAuthorize(data) {
        this.getResourceData()
        this.dialogTitle = '授权'
        this.applicationId = data.id
        let sources = data.sources
        let newSources = []
        sources.map(item => {
          console.log(item)
          newSources.push(item.resource_id)
        })
        this.resourceIds = newSources
        this.authorizeDialog = true
      },
      lookDetail(data) {
        this.dialogTitle = '应用详情'
        this.detailDialog = true
        this.detailForm = data
      },
      // 分页
      pageChange(page) {
        this.pageParams.currentPage = page.currentPage
        this.pageParams.pageSize = page.pageSize
        this.getTableData()
      },
      searchHandle() {
        this.queryParams.page = 1
        this.pageParams.currentPage = 1
        this.getTableData()
      },
      // 是否启用
      changeSwitch(val, data) {
        let flag = data.is_enabled
        if (data.is_enabled === 0) {
          data.is_enabled = 1
        } else {
          data.is_enabled = 0
        }
        let that = this
        this.$confirm(`是否更改【${data.app_name}】状态`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        })
          .then(() => {
            let params = {
              status: val
            }
            appApi.isEnabledApp(data.id, params).then((res) => {
              if (res.code === 0) {
                flag === 1 ? (data.is_enabled = 1) : (data.is_enabled = 0)
                that.getTableData()
                that.$message.success(res.msg)
              } else {
                that.$message.error(res.msg)
              }
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消更改!'
            })
          })
      },
      // 资源授权
      closeHandle() {
        this.applicationId = ''
        this.applicationForm = {}
        this.$refs['applicationForm'].resetFields()
      },
      authorizeSave() {
        this.authorizeForm = {
          resource_ids: this.resourceIds
        }
        console.log(this.authorizeForm)
        this.authorizeLoading = true
        appApi.authorizeApp(this.applicationId, this.authorizeForm).then(res => {
          if (res.code === 0) {
            this.$message.success(res.msg)
            this.authorizeDialog = false
            this.getTableData()
          }
          this.authorizeLoading = false
        }).catch((err) => {
          this.authorizeLoading = false
          console.log(err)
        })
      },
      // 重置secret
      resetSecret(data) {
        let that = this
        this.$confirm(`确定重置SECRET吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          appApi.resetSecret(data.id).then(res => {
            if (res.code === 0) {
              that.$message.success(res.msg)
              that.authorizeDialog = false
              that.getTableData()
            }
          }).catch((err) => {
            console.log(err)
          })
        }).catch(() => {
          that.$message({
            type: 'info',
            message: '已取消重置!'
          })
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/styles/variables.scss";
    .application{
        padding-top: 24px;
    }
   .applicationForm-content {
    .el-form-item:last-child {
      margin-bottom: 0;
    }

    .el-checkbox-group {
      margin-bottom: -16px;

      .el-checkbox.is-bordered {
        vertical-align: top;
        margin-bottom: 16px;
        width: 240px;
        margin-left: 0;
        margin-right: 16px;

        &:nth-child(2n) {
          margin-right: 0;
        }
      }
    }
  }
</style>
